































import {
  computed, defineComponent, reactive, ref, watch,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import CommonHubSelector from '@/components/CommonHubSelector.vue';
import ChartWithMoneyAxis from '@/components/Vivat/Chart/ChartWithMoneyAxis.vue';

import {
  NOW_START_MONTH,
  NOW_END_MONTH,
  monthDays,
} from '@/utils';
import { useQuery } from '@vue/apollo-composable';

const ChartWithSelectedMonth = defineComponent({
  components: {
    CommonHubSelector,
    ChartWithMoneyAxis,
  },
  props: {
    query: {
      default: undefined,
    },
    result: {
      type: Function,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
    formatYAxis: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: '180',
    },
    showPercentageLine: { type: Boolean, default: false },
    yTicks: { type: Object, default: undefined },
  },
  setup(props) {
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });
    const max = ref(0);
    const min = ref(0);
    const endOfMonth = computed(() => {
      const curMonth = filter.monthRange.to;
      return useFormat.date(curMonth).computerShortDateEndOfMonth() - 1;
    });

    const { result, loading } = useQuery(
      props.query as any,
      computed(() => ({
        filterCreatedAtBetween: filter.monthRange,
        filterHubId: filter.hub && (filter.hub as any).id ? (filter.hub as any).id : undefined,
      })),
      () => ({
        fetchPolicy: 'network-only',
        enabled: props.query !== undefined && props.result !== undefined,
      }),
    );

    const rawData = computed(() => {
      if (loading.value === false && result.value && props.result !== undefined) {
        return {
          deliveryStatusByDateRange: props.result(result.value),
        };
      }
      return { deliveryStatusByDateRange: [] };
    });

    const mapRawDataIntoFormat = computed(() => {
      const pendingOrder: any = [];
      const inprogressOrder: any = [];
      const successOrder: any = [];
      const incompleteOrder: any = [];
      for (let i = 0; i < rawData.value.deliveryStatusByDateRange.length; i += 1) {
        pendingOrder.push(rawData.value?.deliveryStatusByDateRange[i]?.count?.filter((item: any) => item.status === 'PENDING' || item.status === 'WAITING_TO_CONFIRM')[0]?.count || 0);
        successOrder.push(rawData.value?.deliveryStatusByDateRange[i]?.count?.filter((item: any) => item.status === 'SUCCESS')[0]?.count || 0);
        incompleteOrder.push(rawData.value?.deliveryStatusByDateRange[i]?.count?.filter((item: any) => item.status === 'NOT_SUCCESS')[0]?.count || 0);

        const sumInprogressOrder = rawData.value?.deliveryStatusByDateRange[i]?.count?.filter((item: any) => item.status === 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER' || item.status === 'PREPARE_TO_DELIVER' || item.status === 'ON_THE_WAY' || item.status === 'HUB');

        inprogressOrder.push(sumInprogressOrder.reduce((acc: any, item: any) => acc + item.count, 0));
        const sum = rawData.value?.deliveryStatusByDateRange[i]?.count?.reduce((acc: any, item: any) => acc + item.count, 0) + 3;
        if (sum > max.value) max.value = sum;
        if (sum < min.value) min.value = sum;
      }
      return {
        inprogressOrder,
        successOrder,
        incompleteOrder,
        pendingOrder,
      };
    });

    watch(() => result.value, (newVal, oldVal) => {
      if (newVal !== oldVal) {
        max.value = 0;
        min.value = 0;
      }
    });

    const chartData = computed(() => ({
      labels: monthDays(filter.monthRange.from, filter.monthRange.to),
      datasets: [
        {
          label: 'รอรับเข้าระบบ',
          data: mapRawDataIntoFormat.value.pendingOrder,
          backgroundColor: '#a0aec0',
          stack: 'CURRENT',
        },
        {
          label: 'ระหว่างดำเนินการ',
          data: mapRawDataIntoFormat.value.inprogressOrder,
          backgroundColor: '#ecc94a',
          stack: 'CURRENT',
        },
        {
          label: 'รายการส่งสำเร็จ',
          data: mapRawDataIntoFormat.value.successOrder,
          backgroundColor: '#49bb78',
          stack: 'CURRENT',
        },
        {
          label: 'รายการส่งไม่สำเร็จ',
          data: mapRawDataIntoFormat.value.incompleteOrder,
          backgroundColor: '#f56565',
          stack: 'CURRENT',
        },
      ],
    }));

    return {
      endOfMonth,
      filter,
      chartData,
      rawData,
      max,
      min,
    };
  },
});

export default ChartWithSelectedMonth;
